import { Property, IProperty } from '@clooper/core';
import { Pipe, PipeTransform } from '@angular/core';
/**
  * PropertyAddressPipe
  *
  * A pipe to transform a property object into a string representation of an address.
  */
@Pipe({ name: 'propertyAddress' })
export class PropertyAddressPipe implements PipeTransform {
  /**
  * Transforms passed in value into an address string that might consist of street, city, state, and country.
  *
  * @param {IProperty|Property} property A property Object.
  * @return {string} Returns a constructed string representation of address.
  */
  transform(property: IProperty | Property): string {
    const { street, city, state, country } = property.address;
    const address = `${street}, ${city}, ${state}, ${country}`;
    return address;
  }
}
